import React, { lazy } from 'react';
import { Testimonials } from '../components/Testimonials';
import { motion } from 'framer-motion';
export function Cases() {
  const handleScheduleCall = () => {
    window.location.href = 'https://calendly.com/dj-casesoncommand/demo?utm_source=ads&utm_medium=ads&utm_campaign=ads';
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-149">
      <div className="pt-24 pb-12 px-6 md:px-12" style={{
      backgroundColor: '#F7F5F0'
    }} data-id="element-150">
        <div className="max-w-6xl mx-auto text-center" data-id="element-151">
          <div className="inline-block bg-white rounded-full px-8 py-3 mb-6" data-id="element-152">
            <p className="font-display text-base md:text-xl font-medium text-navy/70" data-id="element-153">
              New ✨ For Immigration Firms Seeking More Talent Visa Cases
            </p>
          </div>
          <h1 className="font-display text-2xl md:text-6xl font-bold mb-6 text-navy" data-id="element-154">
            We'll Guarantee You Qualified Employment Visa Cases - And You Only
            Pay For Results
          </h1>
          <p className="text-lg text-navy/80 max-w-3xl mx-auto mb-8" data-id="element-155">
            No Retainers. No Website Required. No Advertising Expense.
          </p>

          <div className="max-w-4xl mx-auto mb-8" data-id="element-156">
            <div style={{
            position: 'relative',
            paddingTop: '56.25%'
          }} data-id="element-157">
              <iframe src="https://iframe.mediadelivery.net/embed/545778/24a977a0-ff54-4bb0-9da8-07c91ba26f6e?autoplay=true&loop=false&muted=true&preload=false&responsive=false" loading="lazy" style={{
              border: 0,
              position: 'absolute',
              top: 0,
              height: '100%',
              width: '100%'
            }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-158" />
            </div>
          </div>

          <motion.button onClick={handleScheduleCall} className="bg-primary hover:bg-primary-hover text-black font-bold text-2xl py-6 px-20 rounded-full transition-all hover:-translate-y-0.5 active:translate-y-0 mb-8 shadow-lg" animate={{
          x: [0, -2, 2, -2, 2, 0]
        }} transition={{
          duration: 0.5,
          repeat: Infinity,
          repeatDelay: 3,
          ease: 'easeInOut'
        }} data-id="element-159">
            Schedule a Call
          </motion.button>

          <div className="mt-12 flex flex-wrap justify-center items-center gap-8 md:gap-12 text-navy/70" data-id="element-160">
            <div className="flex items-center gap-2" data-id="element-161">
              <span className="text-2xl" data-id="element-162">•</span>
              <span className="text-sm md:text-base" data-id="element-163">
                Trusted by 50+ Immigration & Law Firms
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-164">
              <span className="text-2xl" data-id="element-165">•</span>
              <span className="text-sm md:text-base" data-id="element-166">
                4.9/5 Client Satisfaction
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-167">
              <span className="text-2xl" data-id="element-168">•</span>
              <span className="text-sm md:text-base" data-id="element-169">
                Industry-Leading Results
              </span>
            </div>
          </div>
        </div>
      </div>
      <Testimonials data-id="element-170" />
    </div>;
}